import { createContext, untrack, useContext, type JSX } from 'solid-js';
import { getFunnelRuntime, type FunnelRuntime } from './funnelRuntime';

const RuntimeContext = createContext<FunnelRuntime>();

export interface RuntimeProviderProps {
  /** Defaults to the app-wide singleton; tests pass their own. */
  runtime?: FunnelRuntime;
  children: JSX.Element;
}

/** Sits above the router, so the runtime outlives every route mount. */
export const RuntimeProvider = (props: RuntimeProviderProps) => {
  // Fixed for the app's lifetime on purpose: pages hold the services, they do not re-subscribe.
  const runtime = untrack(() => props.runtime) ?? getFunnelRuntime();
  return <RuntimeContext.Provider value={runtime}>{props.children}</RuntimeContext.Provider>;
};

/** A page rendered without the provider (tests, the payments test build) gets the singleton — same behaviour. */
export const useFunnelRuntime = (): FunnelRuntime => useContext(RuntimeContext) ?? getFunnelRuntime();
